import { Button } from 'ui';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Theme, css } from '@emotion/react';
import { consumer } from '@tock/coretypes';
import AnchorV2 from 'components/AnchorV2';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import React, { FunctionComponent } from 'react';

const existingWidgetsTableButton = ({ spacing }: Theme) => css`
  margin-left: ${spacing(1.5)}px;
`;

interface ExistingWidgetsTableProps {
  widgets: consumer.NamedConfiguration[];
  onArchiveWidget(id: number): void;
}

export const ExistingWidgetsTable: FunctionComponent<
  React.PropsWithChildren<ExistingWidgetsTableProps>
> = ({ widgets, onArchiveWidget }) => {
  return (
    <TableContainer>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Name</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {widgets.map(({ name, id }) => (
            <TableRow key={id}>
              <TableCell align="left">{name}</TableCell>
              <TableCell align="right">
                <Button
                  component={AnchorV2}
                  href={`/tock/consumer-page-widgets/edit/${id}`}
                  endIcon={<EditIcon />}
                  name="Edit"
                >
                  Edit
                </Button>
                <Button
                  endIcon={<DeleteIcon />}
                  variant="outlined"
                  color="danger"
                  onClick={() => onArchiveWidget(id)}
                  css={existingWidgetsTableButton}
                  name="Archive"
                >
                  Archive
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
